import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "form-check"
}
const _hoisted_2 = ["value", "checked", "name", "disabled", "id", "title"]
const _hoisted_3 = ["for"]
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Mode FORM_GRID not yet implemented. ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Found illegal mode ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (this.isFlexMode)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("input", {
          class: "form-check-input",
          type: "radio",
          value: this.value,
          checked: this.selected == this.value,
          name: this.name,
          disabled: _ctx.disabled,
          id: this.id != null ? this.id : _ctx.$id('radioButton'),
          title: this.title,
          onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.changed && _ctx.changed(...args))),
          ref: "radioButton"
        }, null, 40, _hoisted_2),
        (this.label != null)
          ? (_openBlock(), _createElementBlock("label", {
              key: 0,
              class: "form-check-label",
              for: this.id != null ? this.id : _ctx.$id('radioButton')
            }, _toDisplayString(this.label), 9, _hoisted_3))
          : _createCommentVNode("", true)
      ]))
    : (this.isFormGridMode)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _hoisted_4
        ], 64))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          _hoisted_5
        ], 64))
}